export default {
  mapApi: {
    getProjectMapLayers: `/map/project/getProjectMapLayers`,
    getProjectMap: `/map/project/getProjectMap`
  }
}



// WEBPACK FOOTER //
// ./src/request/ports.js